import {
    BaseLayer,
    BaseLayerFactory_3857,
    BaseLayerType
}
from "esdm-map";

import { IBaseLayer } from "esdm-map/dist/baselayers/interfaces/IBaseLayer";
import TileLayer from "ol/layer/Tile";
import * as olProj from 'ol/proj';
import XYZ from 'ol/source/XYZ';

export const LincolnshireBaseLayers = {
    ...BaseLayerType,
    OrdnanceSurvey_1888to1913: 999,
    OrdnanceSurvey_1937to1961: 1000
};

export class LincolnshireBaseLayerFactory extends BaseLayerFactory_3857 {

  
    public GetBaseLayerByType(baseLayerType: BaseLayerType, bingApiKey: string = "", esdmApiKey: string = ""): IBaseLayer {

        switch (baseLayerType) {
            case LincolnshireBaseLayers.OrdnanceSurvey_1888to1913:
                return this.GetOrdnanceSurvey_1888to1913();

            case LincolnshireBaseLayers.OrdnanceSurvey_1937to1961:
                return this.GetOrdnanceSurvey_1937to1961();
        }


        return super.GetBaseLayerByType(baseLayerType, bingApiKey, esdmApiKey);
    }

    private GetOrdnanceSurvey_1937to1961(): IBaseLayer {
        const lyr = new TileLayer({
            extent: olProj.transformExtent([-7.68, 49.8, 1.77, 60.4], 'EPSG:4326', 'EPSG:3857'),
            preload: Infinity,            
            source: new XYZ({
                urls: [
                    'https://api.maptiler.com/tiles/uk-osgb25k1937/{z}/{x}/{y}.jpg?key=6hb2pqnreHBu6FCIVmfM'
                ],
                minZoom: 1,
                maxZoom: 18,
                attributions: 'Mapping from <a href="https://www.nls.uk/">National Library of Scotland</a>',
                crossOrigin: "Anonymous"
            }),            
            visible: false
        });

        return new BaseLayer("OS25k1937", "OS 1:25,000 1937-1961", lyr);
    }

    private GetOrdnanceSurvey_1888to1913(): IBaseLayer {
        const lyr = new TileLayer({
            extent: olProj.transformExtent([-7.68, 49.8, 1.77, 60.4], 'EPSG:4326', 'EPSG:3857'),
            preload: Infinity,            
            source: new XYZ({
                urls: [
                    'https://api.maptiler.com/tiles/uk-osgb10k1888/{z}/{x}/{y}.jpg?key=6hb2pqnreHBu6FCIVmfM'
                ],
                minZoom: 1,
                maxZoom: 18,
                attributions: 'Mapping from <a href="https://www.nls.uk/">National Library of Scotland</a>',
                crossOrigin: "Anonymous"
            }),                
            visible: false            
        });

        return new BaseLayer("OS10k1888", "OS 1:10,000 1888-1913", lyr);
    }

}